import type GamePosition from '~/models/game/GamePosition'
import type {TClickableCardStateV2} from '~/pages/GameLobbyV2/clickableCardState'
import {
  clickableCardIdsFor,
  fadeUnclickableCardsFor,
  highlightedCardIdsFor,
  selectedCardIdsFor,
} from '~/pages/GameLobbyV2/clickableCardState'

// dragging, animating, and hover states can join this record later
export type TCardVisualState = {
  clickable: boolean
  selected: boolean
  highlighted: boolean
  faded: boolean
  fadeUnclickable: boolean
}

// Curried so the sets are built once per render; the returned lookup is cheap per card.
export const cardVisualStates = (
  clickableCardState: TClickableCardStateV2,
  currentGamePosition: GamePosition
): ((cardId: string) => TCardVisualState) => {
  const clickable = clickableCardIdsFor(clickableCardState)
  const selected = selectedCardIdsFor(clickableCardState)
  const fadeUnclickableCards = fadeUnclickableCardsFor(clickableCardState)
  const highlighted = highlightedCardIdsFor(clickableCardState, currentGamePosition)
  const hasHighlights = highlighted.size > 0

  return cardId => {
    const isClickable = clickable.has(cardId)
    const isSelected = selected.has(cardId)
    const isHighlighted = hasHighlights && highlighted.has(cardId)
    return {
      clickable: isClickable,
      selected: isSelected,
      highlighted: isHighlighted,
      faded: hasHighlights && !isHighlighted,
      fadeUnclickable:
        fadeUnclickableCards && !isClickable && !isSelected && !isHighlighted,
    }
  }
}
